import { ICON_PATH } from './consts'
import logger from 'shared/services/logger'

export const getIconPath = path => {
  const iconPath = ICON_PATH[path]

  if (iconPath) {
    return iconPath
  }

  logger.error(`Icon path not found: ${path}`)
  return ICON_PATH.circleInfo
}
